<template>
  <div :class="['rb-custom-checkbox', { 'rb-selected': isSelected }]">
    <button
      class="rb-cs-button"
      aria-label="Select/Unselect"
      @click.prevent="changeSelect"
      :id="`step-diamond--choice-${diamond.cert_num}`"
      ref="rb-custom-checkbox"
    >
      <span>
        <icon-check />
      </span>
    </button>
    <label v-if="label" @click.prevent="changeSelect">
      <template v-if="isSelected">{{ txtSelected }}</template>
      <template v-else>{{ txtUnselected }}</template>
    </label>
  </div>
</template>
<script>
/**
 * Custom Checkbox including label and behavior specific for different states
 *
 * @props
 * selected: Boolean
 * label: Boolean
 *
 * @implements
 * TrackMixin
 *
 * @emits
 * rb-selected
 * rb-deselected
 */
import TrackMixin from "@/mixins/TrackMixin";
import FormattersMixin from "@/mixins/FormattersMixin";
import IconCheck from "@/components/icons/IconCheck";
export default {
  mixins: [TrackMixin, FormattersMixin],
  components: { IconCheck },
  props: {
    selected: { type: Boolean, default: false },
    label: { type: Boolean, default: false },
    diamond: { type: Object, required: true },
  },
  data: function () {
    return {
      txtUnselected: "Select diamond",
      txtSelected: "Selected",
      isSelected: false,
    };
  },
  mounted: function () {
    this.isSelected = this.selected;
  },
  watch: {
    selected: function () {
      this.isSelected = this.selected;
    },
  },
  methods: {
    changeSelect: function () {
      this.isSelected = !this.isSelected;
      this.$emit(this.isSelected ? "rb-selected" : "rb-deselected");
      if (this.isSelected) {
        this.trackEvent(
          this.formatTracking(
            this.getTrackId({ currentTarget: this.$refs["rb-custom-checkbox"] })
          ),
          this.deuniquefyId(
            this.getTrackId({ currentTarget: this.$refs["rb-custom-checkbox"] })
          ),
          {
            carat: this.formatCarats(this.diamond.size),
            clarity: this.diamond.clarity,
            color: this.diamond.color,
          }
        );
      }
    },
  },
};
</script>
